/* service-product.js — タブ / ギャラリー / プラン選択 / Q&A / GA4 計測 */
(function () {
  'use strict';

  function track(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, params));
  }

  function initSection(root) {
    if (!root || root.dataset.svcInit === '1') return;
    root.dataset.svcInit = '1';

    /* ---- タブ ---- */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-svc-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-svc-panel]'));

    function selectTab(id, userInitiated) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.svcTab === id)); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.svcPanel === id); });
      if (userInitiated) {
        track('service_tab_view', { tab_id: id, product: root.dataset.productHandle || '' });
        history.replaceState(null, '', '#tab-' + id);
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { selectTab(t.dataset.svcTab, true); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); selectTab(n.dataset.svcTab, true);
        }
      });
    });

    var hash = (location.hash || '').replace('#tab-', '');
    if (hash && tabs.some(function (t) { return t.dataset.svcTab === hash; })) selectTab(hash, false);

    /* ---- 画像ギャラリー（デスクトップ：切替 ／ モバイル：スワイプ） ---- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-svc-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-svc-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-svc-dot]'));
    var viewport = root.querySelector('[data-svc-gallery]');

    function selectSlide(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', String(n === i)); });
      dots.forEach(function (d, n) { d.setAttribute('aria-selected', String(n === i)); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        selectSlide(i);
        track('service_gallery_view', { image_index: i + 1 });
      });
    });
    if (viewport) {
      var raf;
      viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (getComputedStyle(viewport).overflowX !== 'auto') return;
          var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
          dots.forEach(function (d, n) { d.setAttribute('aria-selected', String(n === i)); });
        });
      }, { passive: true });
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (viewport) viewport.scrollTo({ left: viewport.clientWidth * i, behavior: 'smooth' });
      });
    });

    /* ---- プラン選択 ---- */
    var plans = Array.prototype.slice.call(root.querySelectorAll('[data-svc-plan]'));
    var setupOut = root.querySelector('[data-svc-setup]');
    var monthlyOut = root.querySelector('[data-svc-monthly]');
    var barOut = root.querySelector('[data-svc-barprice]');

    plans.forEach(function (p) {
      p.addEventListener('click', function () {
        plans.forEach(function (o) { o.setAttribute('aria-checked', String(o === p)); });
        if (setupOut && p.dataset.setup) setupOut.innerHTML = p.dataset.setup;
        if (monthlyOut && p.dataset.monthly) monthlyOut.innerHTML = p.dataset.monthly;
        if (barOut && p.dataset.setup) barOut.textContent = p.dataset.setup.replace(/<[^>]*>/g, '');
        track('service_plan_select', { plan_name: p.dataset.svcPlan });
      });
    });

    /* ---- Q&A アコーディオン ---- */
    root.querySelectorAll('[data-svc-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !open);
        if (!open) track('service_faq_open', { question: (btn.textContent || '').trim().slice(0, 80) });
      });
    });

    /* ---- CTA 計測 ---- */
    root.querySelectorAll('[data-svc-cta]').forEach(function (a) {
      a.addEventListener('click', function () {
        var active = root.querySelector('[data-svc-tab][aria-selected="true"]');
        track('service_cta_click', {
          cta: a.dataset.svcCta,
          active_tab: active ? active.dataset.svcTab : '',
          plan: (root.querySelector('[data-svc-plan][aria-checked="true"]') || {}).dataset
            ? root.querySelector('[data-svc-plan][aria-checked="true"]').dataset.svcPlan : ''
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-svc-root]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target.querySelector('[data-svc-root]'));
  });
  if (document.readyState !== 'loading') initAll();
})();
